const EducatorShadow = () => {
  return (
    <svg
      width="121"
      height="160"
      viewBox="0 0 121 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_312_14067)">
        <g filter="url(#filter0_f_312_14067)">
          <circle
            cx="85.022"
            cy="150"
            r="24"
            fill="#051414"
            fillOpacity="0.19"
          />
        </g>
        <g filter="url(#filter1_f_312_14067)">
          <circle
            cx="46.022"
            cy="47"
            r="24"
            fill="#051414"
            fillOpacity="0.19"
          />
        </g>
        <g filter="url(#filter2_f_312_14067)">
          <path
            d="M43.022 74C50.2017 74 56.022 60.1208 56.022 43C56.022 25.8792 50.2017 12 43.022 12C35.8423 12 30.022 25.8792 30.022 43C30.022 49.8839 30.9629 56.2437 32.5548 61.388C30.3209 59.8329 27.9614 59 25.522 59C11.4387 59 0.0219727 86.7583 0.0219727 121C0.0219727 155.242 11.4387 183 25.522 183C39.6052 183 51.022 155.242 51.022 121C51.022 102.168 47.5688 85.2971 42.1179 73.9262C42.4166 73.9751 42.7181 74 43.022 74Z"
            fill="#051414"
            fillOpacity="0.19"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_312_14067"
          x="48.022"
          y="113"
          width="74"
          height="74"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.5"
            result="effect1_foregroundBlur_312_14067"
          />
        </filter>
        <filter
          id="filter1_f_312_14067"
          x="9.02197"
          y="10"
          width="74"
          height="74"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.5"
            result="effect1_foregroundBlur_312_14067"
          />
        </filter>
        <filter
          id="filter2_f_312_14067"
          x="-12.978"
          y="-1"
          width="82"
          height="197"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.5"
            result="effect1_foregroundBlur_312_14067"
          />
        </filter>
        <clipPath id="clip0_312_14067">
          <rect
            width="120"
            height="160"
            fill="white"
            transform="translate(0.0219727)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EducatorShadow;
